import { defineComponent as _defineComponent } from 'vue'
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import { ApiService, LogService, SnackbarService } from "@/services";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadWithCustomLogoBtn',
  props: {
    disabled: { type: Boolean, default: false },
    downloadUrl: { default: "" }
  },
  setup(__props: any) {



const dialog = ref(false);
const loading = ref(false);

const requestCustomLogo = (): void => {
  loading.value = true;
  ApiService.postUserContact("", true).then((response) => {
    if (response.statusCode === 200) {
      LogService.info(`Profile.requestCustomLogo is successful.`);
      SnackbarService.displaySnackbar(
        "Request for custom logo successfully submitted.",
        "primary"
      );
    } else {
      LogService.error(
        `Profile.requestCustomLogo failed: '${response.error_message}'`
      );
      SnackbarService.displaySnackbar("An error occurred, please try again.");
    }
    dialog.value = false;
    loading.value = false;
  });
};

return { __sfc: true,dialog, loading, requestCustomLogo, NjBtn }
}

})